import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import './styles/AddressBar.css'
import MenuToggle from '../MenuToggle'
import InputShow from './InputShow'
import SearchOrClear from './SearchOrClear'
import MyLocation from './MyLocation'

class AddressBar extends PureComponent {
  render() {
    return (
      <header className="address-bar">
        <MenuToggle />
        <InputShow />
        <SearchOrClear />
        <MyLocation registerEvent={this.props.registerEvent} />
      </header>
    )
  }
}

AddressBar.propTypes = {
  registerEvent: func.isRequired,
}

export default AddressBar



// WEBPACK FOOTER //
// ./src/components/Elements/AddressBar/index.jsx